import {
  BooleanParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

import { PlayerProgressStatusParam } from '@/utils/query/params';

export const queryParams = {
  before: StringParam,
  after: StringParam,
  first: withDefault(NumberParam, 20),
  status: PlayerProgressStatusParam,
  desc: withDefault(BooleanParam, true),
};
